import React from 'react';
import { ReceivingAutomatedListTemplate } from 'themes/modules/receiving/pages';
import { ReceivingAutomatedListViewStore } from 'modules/receiving/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReceivingAutomatedListViewStore(rootStore), 'receivingAutomatedListViewStore')
class ReceivingAutomatedList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<ReceivingAutomatedListTemplate
				{...this.props}
				change={this.props.receivingAutomatedListViewStore.change}
				actions={this.props.receivingAutomatedListViewStore}
				viewStore={this.props.receivingAutomatedListViewStore}
			/>
		);
	}
}

export default ReceivingAutomatedList;
